<app-stages [stages]="stages" currentStage="Projekt organizacji ruchu">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <fieldset>
      <div class="row">
        <div class="col-md-3">
          <div class='form-group' *ngIf='"projectType" as controlName'>
            <label [for]='controlName'>
              Typ projektu *
            </label>
            <select
              (change)="form.projectTypeChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.projectTypes'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Lokalizacja *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu lokalizację'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <div class='form-group' *ngIf='"trafficOrganizationDescription" as controlName'>
            <label [for]='controlName'>
              Opis projektu organizacji ruchu *
            </label>
            <textarea
              rows="4"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu opis'>
            </textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Działki
      </legend>
      <app-parcels-crud tag="parcels" formControlName="parcels">
      </app-parcels-crud>
    </fieldset>
    <fieldset>
      <div class="row">
        <div class="col-md-3">
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              Data początku *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.endDate) {
          <div class="col-md-3">
            <div class='form-group' *ngIf='"endDate" as controlName'>
              <label [for]='controlName'>
                Data końca *
              </label>
              <app-date-picker [id]='controlName' [formControlName]='controlName'>
              </app-date-picker>
              <app-validation-errors
                fieldLabel="Data początku" secondFieldLabel="dacie końca"
                [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
      <div class="row">
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"trafficOrganizationApplicant" as controlName'>
            <label [for]='controlName'>
              Wnioskodawca zmiany organizacji ruchu *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu wnioskodawcę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-6'>
          <div class='form-group' *ngIf='"investor" as controlName'>
            <label [for]='controlName'>
              Inwestor
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu wnioskodawcę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="row">
        @if (form.organizerOrContractorType) {
          <div class="col-md-6">
            <div class='form-group' *ngIf='"organizerOrContractorType" as controlName'>
              <label [for]='controlName'>
                Organizator / Wykonawca *
              </label>
              <select
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'>
                <option value=''>Wybierz</option>
                <option value='Organizator imprezy lub innych czynności na drodze'>
                  Organizator imprezy lub innych czynności na drodze
                </option>
                <option value='Wykonawca robót drogowych'>
                  Wykonawca robót drogowych
                </option>
              </select>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.organizerOrContractorName) {
          <div class='col-md-6'>
            <div class='form-group' *ngIf='"organizerOrContractorName" as controlName'>
              <label [for]='controlName'>
                Nazwa *
              </label>
              <input
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu nazwę'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
